import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_MOBILE_UPDATES_REQUEST,
  FETCH_MOBILE_UPDATES_SUCCESS,
  FETCH_MOBILE_UPDATES_ERROR,
  UPDATE_MOBILE_UPDATE_REQUEST,
  UPDATE_MOBILE_UPDATE_SUCCESS,
  UPDATE_MOBILE_UPDATE_ERROR,
  REMOVE_MOBILE_UPDATE_SUCCESS,
  REMOVE_MOBILE_UPDATE_ERROR,
  GET_PAGES,
} from 'actionTypes'

const getPages = (page, data, dispatch) => {
  const qtt = data.length
  const qtd = 10
  let pages = Math.floor(qtt / qtd)
  if (qtt % qtd > 0) {
    pages += 1
  }
  const begin = (page - 1) * qtd
  const end = page * qtd
  data = data.slice(begin, end)
  fetchMobileUpdatesSuccess(data, dispatch)

  return {
    type: GET_PAGES,
    pages,
    current: page,
    count: qtt,
  }
}

/*
 * REQUEST MOBILE_UPDATES
 */
export const fetchMobileUpdates =
  (token, page = 1) =>
  (dispatch) => {
    dispatch(fetchMobileUpdatesRequest())

    return new Api(token, dispatch)
      .get(API_URL.MOBILE_UPDATE_LIST)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(page, response.data, dispatch))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchMobileUpdatesError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchMobileUpdatesRequest = () => ({
  type: FETCH_MOBILE_UPDATES_REQUEST,
})

export const fetchMobileUpdatesSuccess = (data, dispatch) => {
  if (data) {
    dispatch(mobileUpdatesSuccess(data))
  }

  dispatch(hideSpinner())
}

const mobileUpdatesSuccess = (data) => ({
  type: FETCH_MOBILE_UPDATES_SUCCESS,
  payload: data,
})

export const fetchMobileUpdatesError = (error) => ({
  type: FETCH_MOBILE_UPDATES_ERROR,
  payload: error,
})

/*
 * SAVE or UPDATE MOBILE_UPDATE
 */
export const update =
  (token, toSave = null) =>
  (dispatch) => {
    dispatch(updateMobileUpdateRequest())

    return new Api(token, dispatch)
      .post(API_URL.MOBILE_UPDATE_SAVE, toSave)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(updateMobileUpdateSuccess(response.data))
        dispatch(hideSpinner())
        dispatch(fetchMobileUpdates(token))
      })
      .catch((error) => {
        dispatch(updateMobileUpdateError(error))
        dispatch(hideSpinner())
      })
  }

export const updateMobileUpdateRequest = () => ({
  type: UPDATE_MOBILE_UPDATE_REQUEST,
})

export const updateMobileUpdateSuccess = (data) => ({
  type: UPDATE_MOBILE_UPDATE_SUCCESS,
  payload: data,
})

export const updateMobileUpdateError = (error) => ({
  type: UPDATE_MOBILE_UPDATE_ERROR,
  payload: error,
})

/*
 * REMOVE MOBILE_UPDATE
 */
export const remove = (token, toRemove) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.MOBILE_UPDATE_REMOVE, toRemove)
    .then(dispatch(showSpinner()))
    .then(() => {
      dispatch(hideSpinner())
      dispatch(removeMobileUpdateSuccess())
      dispatch(fetchMobileUpdates(token))
    })
    .catch((error) => {
      dispatch(removeMobileUpdateError(error))
      dispatch(hideSpinner())
    })

export const removeMobileUpdateSuccess = () => ({
  type: REMOVE_MOBILE_UPDATE_SUCCESS,
})

export const removeMobileUpdateError = (error) => ({
  type: REMOVE_MOBILE_UPDATE_ERROR,
  payload: error,
})
